import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root',
})
export class FileService {
    constructor(private http: HttpClient) {}

    public getFile(fileUrl: string): Observable<any> {
        return new Observable((obs) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', fileUrl, false);
            xhr.onload = function () {
                try {
                    if (this.status == 200) {
                        const content: string = this.response;
                        obs.next(content);
                    } else {
                        obs.error(this.status);
                    }
                } catch (error) {
                    obs.error(error);
                }
            };
            xhr.send();
        });
    }

    public getBlobFile(fileUrl: string): Observable<Blob> {
        return this.http.get(fileUrl, { responseType: 'blob' });
    }

    public downloadExcelFile(downloadLink: string) {
        this.getBlobFile(downloadLink)
            .pipe()
            .subscribe((data) => {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                const filename = downloadLink.substring(downloadLink.lastIndexOf('/') + 1);
                anchor.href = url;

                anchor.download = filename;
                anchor.click();

                // Clean up
                window.URL.revokeObjectURL(url);
            });
    }
}
